import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';

export type AcademyListExport =
  | 'subscriptions' | 'players' | 'teams' | 'trainers' | 'facilities' | 'renters' | 'expenses'
  | 'expense-categories' | 'assets' | 'asset-categories'
  | 'store-categories' | 'store-products' | 'store-orders' | 'packages';

@Injectable({ providedIn: 'root' })
export class AcademyListExportManualService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  export(academyId: number, type: AcademyListExport, params: Record<string, unknown> = {}): Observable<HttpResponse<Blob>> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });

    return this.http.get(`${this.rootUrl}/api/v1/academy/${academyId}/exports/${type}`, {
      params: httpParams,
      observe: 'response',
      responseType: 'blob',
    });
  }
}
